module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagel"
  }, [_c('a', {
    attrs: {
      "id": "ch020"
    }
  }), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0048-01.jpg",
      "width": "450px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One of the most perplexing design projects was Geordi La Forge’s VISOR,” relates scenic artist Michael Okuda. “Gene wanted it to look like cool, advanced technology that wouldn’t distract from LeVar Burton’s good looks. This was an important project, so illustrators Andrew Probert and Rick Sternbach gave it the full-court press under the guidance of Herman Zimmerman. As the show’s graphic artist, I had more than enough work with the ship’s control panels, and I was content to watch the cool stuff that emerged from their drawing boards.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In any design project, it’s normal for the first few concepts to be rejected, as designers get a feel for what the producers want. But this process lasted longer than anyone expected. Through many sketches and prototypes, Gene just wasn’t seeing what he wanted. Even set decorator John Dwyer got into the fray, bringing in a dizzying array of sunglasses from funky stores on Melrose Avenue—to no avail. And time was running out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d just moved to Los Angeles from my hometown of Honolulu. I hadn’t even found an apartment. My friends Jeff and Kiku Annon were kind enough to let me crash at their home. One morning, I noticed that Kiku had an interesting-looking hair clip. Its pattern of ‘teeth’ caught the light, but it wasn’t overly complicated. As a bonus, you could see through the teeth, which would be important if LeVar had to wear it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I asked Kiku if I could borrow the clip, and she said ‘Sure!’ even though "), _c('em', [_vm._v("TNG")]), _vm._v(" was so secretive at this point that I couldn’t tell her what I wanted it for.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I brought the clip to Herman, who studied it closely. Like Gene, Herman always tried to think ‘outside the box,’ and I hoped it might inspire some new thoughts for our illustrators. A moment later, Herman said, ‘I think you may have solved a very difficult design problem.’ He had the clip spray-painted, then headed to Roddenberry’s office. I returned to my duties; I was still racing to finish the control panel graphics for the bridge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The next morning, a delivery person stopped by my desk with a bottle of champagne and a thank-you card from Gene Roddenberry! And for the next seven years, Geordi La Forge wore a visual prosthetic gizmo based on my friend’s hair clip.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sadly, Kiku never got it back. It got lost at the prop shop. Sorry, Kiku!”")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0048-02.jpg",
      "width": "450px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Susan Duchow—Denise Crosby’s stand-in—models the original spray-painted hair clip.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0049-01.jpg",
      "width": "450px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Rick Berman and Gene Roddenberry study an early version of Geordi’s VISOR modeled by an unidentified body double from Central Casting.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12ce12f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch020.vue
// module id = 132
// module chunks = 0